import { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import MDExpensesReportScreen from '../Screens/MDExpensesReportScreen';
import {
  MDList,
  getMdExpensesReport,
  getMdExpensesReportExport,
} from '../../../api/mdExpensesReport';
import Swal from 'sweetalert2';

const today = new Date();
const prior = new Date().setDate(today.getDate() - 20);

const formDefault = {
  md_codes: [],
  from:
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(), //moment().subtract(30, "days").format("YYYY-MM-DD"),
  to:
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(), //moment().subtract(30, "days").format("YYYY-MM-DD"),
  page: 0,
  page_size: 50,
  order_by: 'account_name',
  direction: 'asc',
  sortModel: [],
  filterModel: {
    items: [],
  },
};

const MDExpensesReport = () => {
  const [formData, setFormData] = useState(formDefault);
  const [mdExpensesReportListData, setMdExpensesReportListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mdListDropdown, setMdListDropdown] = useState([]);

  const [tableData, setTableData] = useState({
    ...formData,
    data: [],
    totalRows: 0,
    loading: false,
  });

  useEffect(() => loadMDExpensesReportList(formData), []);

  useEffect(() => loadMDList(), []);

  const loadMDExpensesReportList = async (form) => {
    setLoading(true);
    setTableData({ ...tableData, loading: true });
    let dateFrom = new Date(form.from);
    let dateTo = new Date(form.to);
    let allow = 0;

    if (dateFrom.getTime() === dateTo.getTime()) {
      allow = 1;
    } else if (dateFrom.getTime() < dateTo.getTime()) {
      allow = 1;
    }

    if (allow === 1) {
      try {
        const res = await getMdExpensesReport(form);

        const { code, result, total_rows } = res.data.response;

        let MDData = result;

        let MDListData = MDData.map((row, index) => {
          return {
            id: index,
            transaction_date: row.transaction_date,
            md_code: row.md_code,
            reference: row.reference,
            amount: row.amount,
            cost_center_code: row.cost_center_code,
            cost_center_name: row.cost_center_name,
            account_code: row.account_code,
            account_name: row.account_name,
            program_code: row.program_code,
            program_name: row.program_name,
            particulars: row.particulars,
            remarks: row.remarks,
            details: row.details,
          };
        });

        if (code !== '00000') {
          setTableData({
            ...tableData,
            loading: false,
            data: [],
            totalRows: 0,
          });
          toast.error(Array.isArray(result) ? result.join('<br />') : result);
          return;
        }

        setTableData({
          ...tableData,
          loading: false,
          data: MDListData,
          totalRows: total_rows,
        });
        setMdExpensesReportListData(formData);
      } catch (error) {
        setTableData({ ...tableData, loading: false, data: [], totalRows: 0 });
        toast.error(error.message);
      }
    }
  };

  const loadMDList = async () => {
    try {
      let data = {
        keyword: null,
        status: 1,
      };

      const res = await MDList(data);
      const { code, result } = res.data.response;
      // console.log(result);
      setMdListDropdown(
        result.map((row) => ({
          value: row.md_code,
          label: row.md_profile.first_name + ' ' + row.md_profile.last_name,
          row,
        })),
      );
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getDate = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    //console.log('date', e.target.value);
  };

  const handleChangeMDList = (e) => {
    let newFormData = {
      ...formData,
      //[e.target.name]: e.target.value,
      md_codes: [e.value],
      md_name: e.row.md_profile.first_name + ' ' + e.row.md_profile.last_name,
    };
    setFormData(newFormData);
  };

  const handleSearch = () => {
    loadMDExpensesReportList(formData);
  };

  const handleDataTableChange = (params) => {
    let temp = {
      ...formData,
      ...params,
    };

    loadMDExpensesReportList(temp);
  };

  //console.log('sadsad', tableData);

  const OnHandleExport = () => {
    if (formData.date_from === '' || formData.date_to === '') {
      Swal.fire({
        title: 'Warning',
        text: 'Please select dates!',
        icon: 'warning',
      });
    } else {
      let tmp = {
        md_codes: formData.md_codes,
        from: formData.from,
        to: formData.to,
      };
      toast.loading('Exporting data in progress, Please wait...', {
        position: toast.POSITION.TOP_RIGHT,
      });
      getMdExpensesReportExport(tmp)
        .then((res) => {
          //console.log({ res });
          if (res.data.response.code === '00000') {
            //console.log(res);
            window.location.href = res.data.response.result;
            toast.dismiss();
          } else {
            Swal.fire({
              title: 'Error',
              text: res,
              icon: 'error',
            });
          }
        })
        .catch((err) => {});
    }
  };

  return (
    <Fragment>
      <MDExpensesReportScreen
        formData={formData}
        dateChange={getDate}
        handleSearch={handleSearch}
        handleChange={handleChangeMDList}
        mdExpensesReportListData={mdExpensesReportListData}
        handleExport={OnHandleExport}
        handleDataTableChange={handleDataTableChange}
        tableData={tableData}
        mdListDropdown={mdListDropdown}
      />
    </Fragment>
  );
};

export default MDExpensesReport;
